document.addEventListener("DOMContentLoaded", (event) => {

    var $targetElement = $('.header__garage-dropdown');
    var $targetElementLogin = $('.header__garage-dropdown');
    var $targetElementButton = $('.header__nav-action.item--account');
    var $targetButton = $('.header__nav-action button');
    $(document).on('click', function(event) {
        if (!$targetElement.is(event.target) && $targetElement.has(event.target).length === 0 && !$targetButton.is(event.target) && $targetButton.has(event.target).length === 0) {
            $(".header__garage-dropdown").removeClass("active");
        }
        if (!$targetElementLogin.is(event.target) && $targetElementLogin.has(event.target).length === 0 && !$targetElementButton.is(event.target) && $targetElementButton.has(event.target).length === 0) {
            $("#login-dropdown").hide("slow");
        }
    });

    // Start removing unused data from Car Search List
    var createCarItems = [];
    var cars = document.querySelectorAll("#main_search_data .header__garage-vehicle");
    for (let i = 0; i < cars.length; i++) {
        var getcar_items = cars[i].getAttribute("data-search_parameter");

        if (getcar_items) {
            var splitElement = getcar_items.split(",");
            createCarItems.push({
                "name": splitElement
            });
        }
    }
//     setTimeout(() => {

//         for (i = 0; i < createCarItems.length; i++) {
//             var data = createCarItems[i];
            
//             const cleanedData = data.name.filter(item => item !== "");
         
//             var sentence = cleanedData.join(",");
        
//              console.log(sentence);

//    function searchArrayObject(obj, keyPrefix) {
//     var results = [];
//     var regex = new RegExp('^' + keyPrefix);

//     // Ensure obj is an object and not null
//     if (typeof obj === 'object' && obj !== null) {
//         for (var key in obj) {
//             if (Object.prototype.hasOwnProperty.call(obj, key)) {
//                 if (regex.test(key) && Array.isArray(obj[key]) && obj[key].length > 0 && obj[key][0] !== "") {
//                     results.push({
//                         key: key,
//                         value: obj[key]
//                     });
//                 }
//             }
//         }
//     } else {
//         console.error("Provided obj is not a valid object.");
//     }

//     return results;
// }

// // Usage example
// var array_object = easysearch.tree; // Ensure this is a valid object
// var results = searchArrayObject(array_object, sentence);
//            console.log(results);
//             if (results.length > 0) {
//               for(var i=0;i < results.length; i++){
//                 var removedot = results[i].key.split(",").join(" ");
//                 var mkIdname = removedot.trim().split(" ").join("_");
//                 $("#" + mkIdname).find("a").attr("href", results[i].value[0]);
//               }
              
//             }else {


//                 var removeData = createCarItems[i];
//                 var removesentence = removeData.name.join(",");
//                 console.log("I am Remove Data " + removesentence);

//                 var getStudents = localStorage.getItem("students")
//                 let items = JSON.parse(getStudents)

//                 // The search title to remove
//                 var searchText = removesentence;
//                 console.log("Removed Item" + removesentence);


//                 // Filter the array to remove items with the matching search title
//                 var updatedItems = items.filter(item => item.search_title !== searchText);
//                 var indexToRemove = items.findIndex(item => item.search_title === searchText);
//                 if (indexToRemove == -1) {
//                     // If the item is found, remove it using splice
//                     items.splice(indexToRemove, 1);
//                 }

//                 let students = items;
//                 let string = JSON.stringify(students)
//                 localStorage.setItem("students", string);


//                 let car_data = localStorage.getItem("students")
//                 let total_saved_car = JSON.parse(car_data)
//                 if (total_saved_car.length > 0) {
//                     //$(".car_selector_wrapper h4").html("Customer Car");
//                 }
//                 var selector = document.querySelector("#main_search_data");
//                 var hiddenData = document.querySelector(".hiddenData");


//                 var data = [];

//                 total_saved_car.forEach(function(item) {
//                     // Create a newappenditem
//                     var createHandle = item.search_title.trim().split(" ");
//                     var getHandle = createHandle.join("_");
//                     if (item.search_parameter) {
//                         var search_parameter = item.search_parameter;
//                         var search_parameter_join = item.search_parameter.split(",", 3);
//                         console.log(search_parameter_join);
//                         var search_title = search_parameter_join.join(" ");
//                     } else {
//                         var search_parameter = ",,,";
//                         var createHandle = item.search_title.trim().split(" ");
//                     }
//                     var rawElement = "<div class='header__garage-vehicle' id='" + getHandle + "' data-search_parameter='" + search_parameter + "'><div  class='car_selection_remove icon-far bin-icon'><img src='https://cdn.shopify.com/s/files/1/0632/1176/5919/files/remove_bin_data.png?v=1714394760'/></div> <h5 class='header__garage-vehicle-title icon-far'>" + search_title + "</h5> <a href='" + item.search_link + "' class='btn btn--outline icon-far'>Browse Parts</a> </div>"


//                     // Append the paragraph to the display element
//                     $(hiddenData).append(rawElement);
//                 });
//                 $(selector).html($(".hiddenData").html());
//                 $(".hiddenData").empty();

//             }


//         }
//     }, 5000);



    // End Of Code


    $(document).on("click", ".collection_list_wrapper button", function() {
        $(this).toggleClass("open");
    });

    $(document).on('click', ".product-card-horizontal .minus", function() {

        var getInput = $(this).next();
        var inputValue = getInput[0].value;
        if (inputValue > 1) {
            var minuformula = inputValue - 1;
            $(getInput).attr("value", minuformula);
            var getparentItem = $(this).closest(".product_atc_quantity_wrap").find(".product-action form input[name='quantity']");
            $(getparentItem).val(minuformula);
        }

    });
    $(document).on('click', ".product-card-horizontal .plus", function() {
        var getInput = $(this).prev();
        var inputValue = getInput[0].value;

        var makeitnum = parseInt(inputValue);
        var plusformula = makeitnum + 1;
        $(getInput).attr("value", plusformula);
        var getparentItem = $(this).closest(".product_atc_quantity_wrap").find(".product-action form input[name='quantity']");
        $(getparentItem).val(plusformula);
    });


    $(document).on('click', ".header__garage-actions a", function() {
        $("#ytm-popup").addClass("active");
    })
    $(document).on('click', ".item--car-select button", function() {
        $(".header__garage-dropdown").toggleClass("active");
    })



    $(document).on('click', " .car_selection_remove", function(e) {
        e.preventDefault();
        var removeKey = $(this).closest(".header__garage-vehicle").attr("data-search_parameter");
        console.log(removeKey);
        var getStudents = localStorage.getItem("students")
        let items = JSON.parse(getStudents)
        var removeKey_split = removeKey.split(",");
        var removeKey_join = removeKey_split.join(" ");
        // The search title to remove
        var searchText = removeKey_join;
        console.log("I am search text " + searchText);
        // Filter the array to remove items with the matching search title
        var updatedItems = items.filter(item => item.search_title !== searchText);
        var indexToRemove = items.findIndex(item => item.search_title === searchText);
        console.log(updatedItems);
        if (indexToRemove !== -1) {
            // If the item is found, remove it using splice
            items.splice(indexToRemove, 1);
        }

        let students = items;
        let string = JSON.stringify(students)
        localStorage.setItem("students", string);


        let car_data = localStorage.getItem("students")
        let total_saved_car = JSON.parse(car_data)
        if (total_saved_car.length > 0) {
            //$(".car_selector_wrapper h4").html("Customer Car");
        }
        var selector = document.querySelector("#main_search_data");
        var hiddenData = document.querySelector(".hiddenData");


        var data = [];

        total_saved_car.forEach(function(item) {
            // Create a newappenditem
            var createHandle = item.search_title.trim().split(" ");
            var getHandle = createHandle.join("_");
            if (item.search_parameter) {
                var search_parameter = item.search_parameter;
                var search_parameter_join = item.search_parameter.split(",", 3);
                console.log(search_parameter_join);
                var search_title = search_parameter_join.join(" ");
            } else {
                var search_parameter = ",,,";
                var createHandle = item.search_title.trim().split(" ");
            }



            var rawElement = "<div class='header__garage-vehicle' id='" + getHandle + "' data-search_parameter='" + search_parameter + "'><div  class='car_selection_remove icon-far bin-icon'><img src='https://cdn.shopify.com/s/files/1/0632/1176/5919/files/remove_bin_data.png?v=1714394760'/></div> <h5 class='header__garage-vehicle-title icon-far'>" + search_title + "</h5> <a href='" + item.search_link + "' class='btn btn--outline icon-far'>Browse Parts</a> </div>"

            // Append the paragraph to the display element
            $(hiddenData).append(rawElement);
        });
        $(selector).html($(".hiddenData").html());
        $(".hiddenData").empty();
    })

    $(document).on('click', ".easysearch-btn-holder a", function(e) {
      
        if (localStorage.getItem("students") === null) {

            var students = [];
            var searchItem = [];

            $(".easysearch-holder .easysearch-select-holder").each(function() {
                var data = $(this).find("select").val();
                if (data != "") {
                    searchItem.push(data);
                }

            });

        
            var capitalizedString = searchItem.map(function(word) {
            
                return word.charAt(0).toUpperCase() + word.slice(1);
            }).join(" "); // Join with a space to create a string
            var data_search_item = searchItem.join(",");
            var getUrl = $(this).attr("href");

            students.push({
                "search_title": "" + capitalizedString + "",
                "search_parameter": data_search_item,
                "search_link": "" + getUrl + ""
            });

            let string = JSON.stringify(students)
            localStorage.setItem("students", string);



        } else {

            var getUrl = $(this).attr("href");
            let retString = localStorage.getItem("students")
            let retArray = JSON.parse(retString)
            console.log(retArray);
            let students = retArray;
            var searchItem = [];
            $(".easysearch-holder .easysearch-select-holder").each(function() {
                var data = $(this).find("select").val();
                searchItem.push(data);
            });

          console.log(searchItem.length);
            var capitalizedString = searchItem.map(function(word) {
             var removedExtra=word;
              if(removedExtra !="" && removedExtra !=null){
               
                 return removedExtra.charAt(0).toUpperCase() + removedExtra.slice(1);
              }
               
            }).join(" "); // Join with a space to create a string

            var data_search_item = searchItem.join(",");

            students.push({
                "search_title": "" + capitalizedString + "",
                "search_parameter": data_search_item,
                "search_link": "" + getUrl + ""
            });
            let string = JSON.stringify(students)
            localStorage.setItem("students", string);
        }

    
    });



    $(document).on('click', function(event) {
        var target = $(event.target);
        if (!target.closest('.ytm_popup_wrap').length && !target.closest('.parts_search').length) {
            $("#ytm-popup.ytm-popup").removeClass("active");
        }
        if (target.closest('.parts_search').length || target.closest('.header__garage-actions a').length) {
            $("#ytm-popup.ytm-popup").addClass("active");
        }

        if ($(target).find(".partfinder__heading button") && !$(target).closest(".partfinder__container").hasClass("active")) {
            $(target).closest(".partfinder__container").addClass("active");
        } else if ($(target).find(".partfinder__heading button") && $(target).closest(".partfinder__container").hasClass("active") && !$(target).closest(".partfinder__form-container").hasClass("partfinder__form-container")) {
            $(target).closest(".partfinder__container").removeClass("active");

        }

    });

    setTimeout(() => {
        var prelselct = easysearch.preSelect;
        if (prelselct != "") {
            // Filter out empty items
            var filteredArray = prelselct.filter(item => item !== "");

            // Join the filtered items into a sentence without delimiter
            var sentence = filteredArray.join(" ");


            if (filteredArray.length > 0) {
                $(".car_search_action .heading_wrapper h1").html(sentence);
                $(".car_selector_wrapper h4").html(sentence);
                $(".parts_search .title").html("Change Vehicle");
                var rawElement = "<h4 class='header__garage-heading'>Currently Selected:</h4><div class='header__garage-vehicle'><div  class='car_selected_remove icon-far bin-icon'><img src='https://cdn.shopify.com/s/files/1/0632/1176/5919/files/cross_icon_0bdc01cc-31dd-4703-9bba-fb4b86afc36f.png?v=1717360431'/></div> <h5 class='header__garage-vehicle-title icon-far'>" + sentence + "</h5> <a href='https://www.epartsmaster.com/collections/all/" + easysearch.currentTag + "' class='btn btn--outline icon-far'>Browse Parts</a> </div>"
                $("#selected_garrage_wraapper").html(rawElement);
            } else {
                $(".car_search_action .heading_wrapper h1").html("ALL VEHICLE PARTS");
                $(".parts_search .title").html("Set Vehicle");
            }
        }

    }, 1000);

    $(document).on('click', " .car_selected_remove", function() {
        easysearch.clearTagFilter();
    });


    function updateSentence(element) {

        var searchValue1 = $(".easysearch-select-holder select")[0].value;
       
        var searchValue2 = $(".easysearch-select-holder select")[1].value;
     
        var searchValue3 = $(".easysearch-select-holder select")[2].value;
    
      
      if(element){
        var value1Item = $(".easysearch-select-holder select")[0];
        var value1 = value1Item.value;
        var value2Item = $(".easysearch-select-holder select")[1];
        var value2 = value2Item.value;
        var value3Item = $(".easysearch-select-holder select")[2];
        var value3 = value3Item.value;
      }else if(searchValue1 !="" && searchValue2 !="" && searchValue3 !=""){
          
           var value1 = searchValue1;
           var value2 = searchValue2;
           var value3 = searchValue3;
      }else{
           var value1 = "";
           var value2 = "";
           var value3 = "";
      }

    
  
        // Construct the sentence
        var sentence = value1 + "," + value2 + "," + value3 + ",";
        console.log("sent:"+sentence);
          
        var array_object = easysearch.tree;
           
        function searchArrayObject(obj, keyPrefix) {
            var results = [];
            var regex = new RegExp('^' + keyPrefix);
            for (var key in obj) {
                if (regex.test(key) && obj[key].length > 0 && obj[key][0] !== "") {
                    results.push({
                        key: key,
                        value: obj[key]
                    });
                }
            }
            return results;
        }

        var results = searchArrayObject(array_object, sentence);
       
        if (results.length > 1) {
   const firstMatch = results
    .flatMap(item => item.value.filter(v => v.includes('collections/')))[0];
         console.log(results[0].value[0]);
            $(".easysearch-select-holder-last select").val(results[0].value[0]);
             $(".easysearch-select-holder-last select").each(function(){
               $(this).val(results[0].value[0]);
             });
            $("#easysearch-search").attr("onclick", "return easysearch.saveSearchParams(this)");
            $("#easysearch-search").removeAttr("disabled");
            $("#easysearch-search").attr("href",firstMatch);
          
            // var categories_list = $(".options-pill-category").data("product-categories");
            // if (categories_list){
            //     var prepairArray = categories_list.split(",");
              
            //     for (let i = 0; i < prepairArray.length; i++) {

             
            //         if (prepairArray[i] === easysearch.currentTag) {

            //             $(".trim_display_wrapper").show();
            //             var trim_data = results[0].value[0];
            //             var prepair_attay_object = trim_data.split('‚');
            //             for (let i = 0; i < prepair_attay_object.length; i++) {
            //                 for (let i = 0; i < results.length; i++) {
            //                     var removeLastcomma = results[i].key;
            //                     var data = removeLastcomma.split(",");
            //                     var newArr = data.filter(item => item !== "");
            //                     if (newArr.length > 3) {
            //                         var prepairData = "<div class='options-pill-wrapper'> <button class='options-pill inactive' type='button'>" + newArr[3] + "</button> </div>";
            //                         $(".options-category-pills").append(prepairData);
            //                     }

            //                 }
            //             }
            //         }
            //     }
            // }



        }

    }
//   $(".collection_list_wrapper-list .collection_item a").on("click",function(){
//     easysearch.clearTagFilter();
// });

    $(document).on("change", '.easysearch-holder .easysearch-select-holder', function(event) {
        updateSentence(event);
    });

    setTimeout(() => {
        updateSentence();
    }, 1000);

    $("#main_search_data .header__garage-vehicle a").on("click", function() {
        easysearch.clearTagFilter();
    });

});